// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderDetails-bookingDetailsNameBox-dCcOw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 12px;
    grid-gap: 12px;
    background: var(--background-primary);
    padding: 24px;
    margin: 6px 0;
}

.ProviderDetails-additionRequestDetailsBox-JmrMm {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 12px;
    grid-gap: 12px;
    background: transparent;
}

.ProviderDetails-providerCardDetailsBox-IkAym {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 12px;
    grid-gap: 12px;
    background: var(--background-primary);
    padding: 12px;
    border-radius: var(--radius-2);
    -webkit-box-shadow: 0px 2px 6px 0px var(--shadow-4);
            box-shadow: 0px 2px 6px 0px var(--shadow-4);
    min-width: 339px;
    max-width: 339px;
}

.ProviderDetails-providerCardDetailsAdditionalPopupImgContainer-Jtjrx {
    position: relative;
    width: 54px;
    height: 54px;
    border-radius: var(--radius-1);
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ProviderDetails-providerCardDetailsImgContainer-Q3R4d {
    position: relative;
    width: 62px;
    height: 62px;
    border-radius: var(--radius-1);
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ProviderDetails-providerCardDetailsImgContainer-Q3R4d img,
.ProviderDetails-providerCardDetailsAdditionalPopupImgContainer-Jtjrx img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    border-radius: inherit;
    -o-object-position: center;
       object-position: center;
}

.ProviderDetails-providerCardDetailsInfoContainer-nTvgr {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 12px;
    grid-gap: 12px;
}

.ProviderDetails-providerCardDetailsHeadingBox-fwmbJ {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    text-align: start;
}

.ProviderDetails-providerCardDetailsHeading-Qh6uz {
    font-size: 18px;
    line-height: 28px;
}

.ProviderDetails-providerCardDetailsDefaultImgContainer-STa3v,
.ProviderDetails-providerCardDetailsAdditionalPopupDefaultImgContainer-oPE0F {
    position: relative;
    width: 62px;
    height: 62px;
    border-radius: 50%;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ProviderDetails-providerCardDetailsDefaultImgContainer-STa3v img,
.ProviderDetails-providerCardDetailsAdditionalPopupDefaultImgContainer-oPE0F img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    border-radius: inherit;
    -o-object-position: center;
       object-position: center;
}

.ProviderDetails-phoneNumberLink-hH5ve {
    display: inline-block;
    font-size: 16px;
    line-height: 26px;
    font-weight: 500;
    color: var(--secondary-foreground);
    text-decoration: unset;
}

.ProviderDetails-providerCardDetailsIconContainer-e6l_l {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    grid-gap: 12px;
}

.ProviderDetails-providerCardDetailsIcon-Ezmo1 {
    position: relative;
    width: 42px;
    height: 42px;
}

.ProviderDetails-providerCardDetailsIcon-Ezmo1 img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    border-radius: inherit;
    -o-object-position: center;
       object-position: center;
}

.ProviderDetails-messageIconNotificationDot-NK01F {
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: var(--common-message-dot-bg);
    top: 10px;
    right: 9px;
    border-radius: 50%;
}

.ProviderDetails-providerDetailsRatingContainer-lcQpN {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 6px;
    margin-top: 6px;
}

.ProviderDetails-providerDetailsRatingContainer-lcQpN>span {
    position: relative;
    width: 12px;
    height: 12px;
}

.ProviderDetails-providerDetailsRatingContainer-lcQpN>span img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
}

.ProviderDetails-providerCardPhoneIconBox-aFny0 {
    display: none;
}

@media (max-width: 767px) {
    .ProviderDetails-bookingDetailsNameBox-dCcOw {
        padding: 18px;
    }

    .ProviderDetails-providerCardDetailsImgContainer-Q3R4d {
        width: 48px;
        height: 48px;
    }

    .ProviderDetails-providerCardDetailsHeading-Qh6uz {
        font-size: 16px;
        line-height: 26px;
    }

    .ProviderDetails-providerCardDetailsIcon-Ezmo1 {
        width: 36px;
        height: 36px;
    }

    .ProviderDetails-messageIconNotificationDot-NK01F {
        width: 6px;
        height: 6px;
    }

    .ProviderDetails-providerCardPhoneIconBox-aFny0 {
        display: inline-block;
    }

}

@media (max-width: 575px) {
    .ProviderDetails-providerCardDetailsBox-IkAym {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
    }

    .ProviderDetails-providerCardDetailsInfoContainer-nTvgr {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ProviderDetails/ProviderDetails.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,qCAAqC;IACrC,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,qCAAqC;IACrC,aAAa;IACb,8BAA8B;IAC9B,mDAA2C;YAA3C,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,oBAAc;QAAd,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,sBAAsB;IACtB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAGA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAc;QAAd,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,sBAAsB;IACtB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,sBAAsB;IACtB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8CAA8C;IAC9C,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;AAEJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,mBAAe;YAAf,eAAe;IACnB;AACJ","sourcesContent":[".bookingDetailsNameBox {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n    background: var(--background-primary);\n    padding: 24px;\n    margin: 6px 0;\n}\n\n.additionRequestDetailsBox {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n    background: transparent;\n}\n\n.providerCardDetailsBox {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n    background: var(--background-primary);\n    padding: 12px;\n    border-radius: var(--radius-2);\n    box-shadow: 0px 2px 6px 0px var(--shadow-4);\n    min-width: 339px;\n    max-width: 339px;\n}\n\n.providerCardDetailsAdditionalPopupImgContainer {\n    position: relative;\n    width: 54px;\n    height: 54px;\n    border-radius: var(--radius-1);\n    flex-shrink: 0;\n}\n\n.providerCardDetailsImgContainer {\n    position: relative;\n    width: 62px;\n    height: 62px;\n    border-radius: var(--radius-1);\n    flex-shrink: 0;\n}\n\n.providerCardDetailsImgContainer img,\n.providerCardDetailsAdditionalPopupImgContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n    object-position: center;\n}\n\n\n.providerCardDetailsInfoContainer {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.providerCardDetailsHeadingBox {\n    flex-grow: 1;\n    text-align: start;\n}\n\n.providerCardDetailsHeading {\n    font-size: 18px;\n    line-height: 28px;\n}\n\n.providerCardDetailsDefaultImgContainer,\n.providerCardDetailsAdditionalPopupDefaultImgContainer {\n    position: relative;\n    width: 62px;\n    height: 62px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.providerCardDetailsDefaultImgContainer img,\n.providerCardDetailsAdditionalPopupDefaultImgContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: inherit;\n    object-position: center;\n}\n\n.phoneNumberLink {\n    display: inline-block;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 500;\n    color: var(--secondary-foreground);\n    text-decoration: unset;\n}\n\n.providerCardDetailsIconContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n\n.providerCardDetailsIcon {\n    position: relative;\n    width: 42px;\n    height: 42px;\n}\n\n.providerCardDetailsIcon img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: inherit;\n    object-position: center;\n}\n\n.messageIconNotificationDot {\n    position: absolute;\n    width: 8px;\n    height: 8px;\n    background-color: var(--common-message-dot-bg);\n    top: 10px;\n    right: 9px;\n    border-radius: 50%;\n}\n\n.providerDetailsRatingContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    margin-top: 6px;\n}\n\n.providerDetailsRatingContainer>span {\n    position: relative;\n    width: 12px;\n    height: 12px;\n}\n\n.providerDetailsRatingContainer>span img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.providerCardPhoneIconBox {\n    display: none;\n}\n\n@media (max-width: 767px) {\n    .bookingDetailsNameBox {\n        padding: 18px;\n    }\n\n    .providerCardDetailsImgContainer {\n        width: 48px;\n        height: 48px;\n    }\n\n    .providerCardDetailsHeading {\n        font-size: 16px;\n        line-height: 26px;\n    }\n\n    .providerCardDetailsIcon {\n        width: 36px;\n        height: 36px;\n    }\n\n    .messageIconNotificationDot {\n        width: 6px;\n        height: 6px;\n    }\n\n    .providerCardPhoneIconBox {\n        display: inline-block;\n    }\n\n}\n\n@media (max-width: 575px) {\n    .providerCardDetailsBox {\n        width: 100%;\n        min-width: 100%;\n        max-width: 100%;\n    }\n\n    .providerCardDetailsInfoContainer {\n        flex-wrap: wrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookingDetailsNameBox": `ProviderDetails-bookingDetailsNameBox-dCcOw`,
	"additionRequestDetailsBox": `ProviderDetails-additionRequestDetailsBox-JmrMm`,
	"providerCardDetailsBox": `ProviderDetails-providerCardDetailsBox-IkAym`,
	"providerCardDetailsAdditionalPopupImgContainer": `ProviderDetails-providerCardDetailsAdditionalPopupImgContainer-Jtjrx`,
	"providerCardDetailsImgContainer": `ProviderDetails-providerCardDetailsImgContainer-Q3R4d`,
	"providerCardDetailsInfoContainer": `ProviderDetails-providerCardDetailsInfoContainer-nTvgr`,
	"providerCardDetailsHeadingBox": `ProviderDetails-providerCardDetailsHeadingBox-fwmbJ`,
	"providerCardDetailsHeading": `ProviderDetails-providerCardDetailsHeading-Qh6uz`,
	"providerCardDetailsDefaultImgContainer": `ProviderDetails-providerCardDetailsDefaultImgContainer-STa3v`,
	"providerCardDetailsAdditionalPopupDefaultImgContainer": `ProviderDetails-providerCardDetailsAdditionalPopupDefaultImgContainer-oPE0F`,
	"phoneNumberLink": `ProviderDetails-phoneNumberLink-hH5ve`,
	"providerCardDetailsIconContainer": `ProviderDetails-providerCardDetailsIconContainer-e6l_l`,
	"providerCardDetailsIcon": `ProviderDetails-providerCardDetailsIcon-Ezmo1`,
	"messageIconNotificationDot": `ProviderDetails-messageIconNotificationDot-NK01F`,
	"providerDetailsRatingContainer": `ProviderDetails-providerDetailsRatingContainer-lcQpN`,
	"providerCardPhoneIconBox": `ProviderDetails-providerCardPhoneIconBox-aFny0`
};
module.exports = ___CSS_LOADER_EXPORT___;
